<template>
    <div>
        <TypeformNPS />
        <PremiumModal />
        <navbar />
        <b-container fluid>
        <b-row>
            <sidebar />
            <main-container />
        </b-row>
        </b-container>
    </div>
</template>
<script>
    import Sidebar from '@/components/Sidebar'
    import Navbar from '@/components/Navbar'
    import MainContainer from '@/components/MainContainer'
    import PremiumModal from '@/components/shared/PremiumModal'
    import TypeformNPS from './TypeformNPS'

    export default {
        components: {
            Sidebar,
            Navbar,
            MainContainer,
            PremiumModal,
            TypeformNPS
        },
        data(){
            return {}
        },
        
    }
</script>
<style lang="scss">
    body{
        background: #E5E5E5 !important;
    }
    .bg-dark h2, 
    .bg-dark p{
        color: #fff !important;
    }

    /* Ajustes css - geral */
    .form-row label,
    .form-row legend {
        padding-bottom: 0px;
        margin-bottom: 0 !important;
    }
    .vs-select--label {
        padding-left: 0 !important;
        font-size: inherit !important;
        color: inherit !important;
    }
    .mx-datepicker-range {
        width: 100% !important;
    }
    .mx-datepicker-popup {
        top: auto !important;
    }
    .mx-input {
        display: inline-block;
        width: 100%;
        height: 38px !important;
    }
    .vs-select--input {
        padding: 6px;
    }
    /* Style interno */
    .header-title{
        color: #4e545a;
    }
    .card-body {
        padding: 10px !important;
    }
    table.el-month-table td.today {
        color: #333333;
    }
    table.el-month-table td.current {
        background: #58a5fe;
        a.cell {
        color: #fff !important;
        }
    }
    .el-input__inner {
        height: 36px;
    }
    .el-input__prefix, .el-input__suffix {
        top: -2px;
    }
    .multiselect .multiselect__tags,
        input.el-input__inner {
            border: 1px solid #bfcedc;
            transition: 0.3s;
            &:hover{
                border-color: #769ec3
            }
        }
        div.modal {
            z-index: 99999;
        }
        .el-message.el-message--error, .el-message.el-message--success,.el-message.el-message--warning{
            z-index: 999999 !important; // alertas
        }

    
    .el-picker-panel__body-wrapper {
        @media screen and (max-width: 580px) {
            margin-left: 75px !important;
        }
        @media screen and (max-width: 500px) {
            margin-left: 0 !important;
        }
    }
    .el-date-range-picker__content {
        @media screen and (max-width: 460px) {
            margin-left: 254px !important;
            width: 58% !important;
        }
        @media screen and (max-width: 370px) {
            margin-left: 300px !important;
            width: 50% !important;
        }
        @media screen and (max-width: 320px) {
            margin-left: 321px !important;
            width: 50% !important;
        }
    }
    .el-date-range-picker__content.is-left {
        @media screen and (max-width: 460px) {
            border:0 !important;
        }
    }

    .el-tabs--border-card .el-tabs__content {
        overflow: inherit;
    }
    div button.aprove-button {
        padding: 14px 0;
        color: #fff;
        text-align: center;
        border-radius: 50%;
        position: fixed;
        z-index: 10;
        cursor: pointer;
        bottom: 20px;
        right: 36px;
        margin-left: 3px;
        background-color: #3ac25b;
        border-color: #3ac25b;
    }
    div button.aprove-button:hover {
        background-color: #37b857;
        border-color: #37b857;
        color:#fff;
    }
    .sub-title{
        padding: 6px 11px 9px;
        width: 100%;
        background: #f3f3f3;
        border-top: 2px solid #cecece;
        border-radius: 3px;
    }
    .sub-container{
        padding: 9px;
        width: 100%;
        /* display: flex; */
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }
    .container-card-toggle {
        padding: 3px 5px;
        margin: 0 -4px;
        font-size: 13px;
        border-radius: 3px;
        -webkit-box-shadow: 0px 0px 1px 1px #bdbdbd;
        box-shadow: 0px 0px 1px 1px #bdbdbd;
        -webkit-transition: 0.2s;
        transition: 0.2s;
    }
    .container-card-toggle {
        background: #fff !important;
    }
    .container-card-toggle:hover {
        background: #f3f3f3;
    }
    .check-all {
        margin-right: 30px !important;
    }
    .depara-checkbox .el-checkbox__input.is-checked .el-checkbox__inner, 
    .depara-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #505050 !important;
        border-color: #505050 !important;
    }

    @import '@/assets/css/treeTable.scss';
    @import '@/assets/css/lightTheme.scss';
</style>